import { Box, Chip } from "@mui/material";
import { formatNumber } from "../roiUtils";
import { RoiCopy } from "../translations";
import { RoiState } from "../types";

interface RoiInputSummaryChipsProps {
  state: RoiState;
  copy: RoiCopy;
  language: string;
}

export default function RoiInputSummaryChips({ state, copy, language }: RoiInputSummaryChipsProps) {
  const chips = [
    `${copy.summarySector}: ${copy.sectors[state.sector]}`,
    `${copy.summaryEmployees}: ${formatNumber(state.employees, language)}`,
    `${copy.summaryProcesses}: ${formatNumber(state.processes, language)}`,
    `${copy.summaryHours}: ${formatNumber(state.weeklyHours, language)} ${copy.weeklyHoursUnit}`,
    `${copy.summaryCost}: ${formatNumber(state.hourlyCost, language)} ${copy.hourlyCostUnit}`,
    `${copy.summaryErrors}: ${formatNumber(state.monthlyErrors, language)} ${copy.perMonth}`,
  ];

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {chips.map((label) => (
        <Chip
          key={label}
          label={label}
          variant="outlined"
          sx={{
            borderColor: "rgba(84, 189, 193, 0.5)",
            backgroundColor: "rgba(84, 189, 193, 0.08)",
            color: (theme) =>
              theme.palette.mode === "dark" ? "primary.main" : "secondary.main",
            fontWeight: 800,
            maxWidth: "100%",
            "& .MuiChip-label": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
      ))}
    </Box>
  );
}
